<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="400px">   
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">

                <el-form-item   prop="title" label="考试名称">
                    <el-input v-model="form.title" maxlength="50" placeholder="如：三年级二班下学期期中考试" style="width:260px;"></el-input>
                </el-form-item>
                <el-form-item  prop="examTime" label="考试时间">
                    <el-date-picker
                        style="width:260px;"
                        v-model="form.examTime"
                        type="date"
                        placeholder="考试时间"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
               <el-form-item label='是否输出平均分'>
                    <el-checkbox  v-model="form.showAvgScoreSwitch"><span style="font-size: 12px;">勾选此选项，展示每科成绩的平均分。</span></el-checkbox>
                </el-form-item>
                  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:undefined,
                    title:undefined,
                    examTime:undefined,
                    showAvgScoreSwitch:undefined,
                },
                rules: {
                    title: [
                        { required: true, message: '请输入考试名称', trigger: 'blur' }
                    ],
                    examTime: [
                        { required: true, message: '请输入考试时间', trigger: 'blur' }
                    ]
                },
            }
        },
        components: {
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                this.form.id=data.id
                this.form.title=data.title
                this.form.examTime=data.examTime
                this.form.showAvgScoreSwitch=data.showAvgScoreSwitch
            },
            dialogClose(done){
                done()
                this.$reload
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.scoreUpdateUrl
                        let data = {
                            id:this.form.id,
                            title:this.form.title,
                            examTime:this.form.examTime,
                            showAvgScoreSwitch:this.form.showAvgScoreSwitch
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1)
                                this.visible=false
                                this.$parent.getData()
                            }else{
                                this.$commonFn.showTip(res.message,3)
                            }
                        }, (err) => {
                            console.log(err)
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/score/Update.vue